"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputGroup = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const tools_1 = require("../../tools");
const Flex_1 = require("../Flex");
function InputGroup(props) {
    return jsx_runtime_1.jsx(StyledFlex, Object.assign({}, props), void 0);
}
exports.InputGroup = InputGroup;
const StyledFlex = tools_1.styled(Flex_1.Flex) `
  input[type='text'] {
    flex: 1;
  }
  input:not(:first-child) /* emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason */,
  button:not(:first-child) /* emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason */,
  select:not(:first-child) /* emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason */ {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
  input:not(:last-child) /* emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason */,
  button:not(:last-child) /* emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason */,
  select:not(:last-child) /* emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason */ {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
`;
//# sourceMappingURL=index.js.map